import script from "./ExportItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportItem.vue?vue&type=script&setup=true&lang=ts"

import "./ExportItem.vue?vue&type=style&index=0&id=0c5c2233&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c5c2233"]])

export default __exports__